import Cookies from 'js-cookie';
import { useState } from 'react';

const COOKIE_OPTS = {
  expires: 10,
  path: '/',
};
const POSITION_KEY = 'spposition';
const FEATURE_SET_KEY = 'spfeatureset';
const SHOW_UNPUBLISHED_KEY = 'spshowunpublished';

const track = (feature_set, value) =>
  global.analytics.track(`staff override`, {
    feature_set,
    value,
  });

export const setStaffPositionOverride = (value, reloadOnChange = true) => {
  track(POSITION_KEY, value);
  Cookies.set(POSITION_KEY, value, COOKIE_OPTS);
  if (reloadOnChange) {
    window.location.reload();
  }
};

export const getStaffPositionOverride = () => Cookies.get(POSITION_KEY);

// The feature set override is set via the UI using this method, but it's read
// from cookies on the request by the server and used to filter the course. The
// get method here is only used to determine the current value of the dropdown on
// the staff ribbon.
export const setStaffFeatureSetOverride = (value) => {
  track(FEATURE_SET_KEY, value);
  Cookies.set(FEATURE_SET_KEY, value, COOKIE_OPTS);
  window.location.reload();
};

export const getStaffFeatureSetOverride = () => Cookies.get(FEATURE_SET_KEY);

export const getShowUnpublished = () => {
  return Cookies.get(SHOW_UNPUBLISHED_KEY) && true;
};

export const setShowUnpublished = (show) => {
  track(SHOW_UNPUBLISHED_KEY, show);
  if (show) {
    Cookies.set(SHOW_UNPUBLISHED_KEY, '1', COOKIE_OPTS);
  } else {
    Cookies.remove(SHOW_UNPUBLISHED_KEY);
  }
  window.location.reload();
};

/*
 * This is a hack to force whatever page we're dropping the staff ribbon
 * on to re-render. It's necessary because the staff ribbon maintains state
 * using browser cookies, which don't trigger a re-render when they change.
 * In some instances simply re-rendering the page (rather than refreshing it)
 * is enough to apply the updates selected in the ribbon, and makes for a much
 * better UX.
 */
export const useForceRerender = () => {
  const [, setToggle] = useState(false);
  return () => setToggle((toggle) => !toggle);
};
